import { getObjects, createObject, updateObject, deleteObject, exportObjects, exportFile_Bilan, getElementsNavigation } from "../../../services/services";
import Conditions from "../../../assets/files/conditions.json";

const combboxElements = [
  { label: "Element A 1001", value: 1 },
  { label: "Element B 1002", value: 2 },
];
export const elementsConfig = {
  title: "Elements",
  entityLabel: "Element",

  idField: "id",

  rowActions: [
    { key: "info", label: "Info", permission: "view_pbsElements", action: "info" },
    { key: "edit", label: "Edit", permission: "edit_pbsElements", action: "edit" },
    { key: "delete", label: "Delete", permission: "delete_pbsElements", action: "delete" },

    { key: "children", label: "Children", permission: "view_pbsElements", action: "filterByParent" },
    { key: "parameters", label: "Parameters", permission: "view_parameters", action: "goToParameters" },
    { key: "requirements", label: "Requirements", permission: "view_cstrRequirements", action: "goToRequirements" },
    { key: "changeRequests", label: "Change Requests", permission: "view_changeRequests", action: "goToChangeRequests" },
    { key: "peekRisks", label: "Peek Risks", permission: "view_risks", action: "goToRisks" },
  ],
  columnActions: [
    { key: "parent_id", label: "Parent", permission: "view_pbsElements", action: "goToElements" },
  ],

  actionHandlers: {
    info: ({ entity, setState, setFormParams }) => {
    setState("info");
    setFormParams([entity]);
    },
    edit: ({ entity, setState, setFormParams }) => {
      setState("edit");
      setFormParams([entity]);
    },
    delete: async ({ entity, setEntityToDelete }) => {
      setEntityToDelete(entity);
    },

    filterByParent: ({ entity, pushFilter }) => {
      pushFilter("parent_id", entity.id, "int");
    },

    goToParameters: ({ entity, navigate }) => {
      localStorage.setItem(
        "filters_Parameters",
        JSON.stringify([{"attribute":"element_id","condition":"==","value":entity.id,"type":"int"}])
      );
      navigate(`/Parameters/1`);
    },

    goToRequirements: ({ entity, navigate }) => {
       localStorage.setItem(
        "filters_CSTR_Requirements",
        JSON.stringify([{"attribute":"element_id","condition":"==","value":entity.id,"type":"int"}])
      );
      navigate(`/CSTR_Requirements/1`);
    },

    goToChangeRequests: ({ entity, navigate }) => {
      localStorage.setItem(
        "filters_Change_requests",
        JSON.stringify([{"attribute":"element_id","condition":"==","value":entity.id,"type":"int"}])
      );
      navigate(`/Change_requests/1`);
    },

    goToRisks: ({ entity, navigate }) => {
      
    },
    goToElements: ({ entity, pushFilter }) => {
      pushFilter("id", entity.parent_id, "int");
    },
  },

  services: {
    list: getObjects,
    create: createObject,
    update: updateObject,
    delete: deleteObject,
    export: exportObjects,
    export_bilan: exportFile_Bilan,
    nav:getElementsNavigation,
    filters: "show",
    columns: "show",

    services_url_names: {
    list: "getElements",
    create: "createElement",
    update: "updateElement",
    delete: "deleteElement",
    export: "exportElements",
    export_bilan: "exportElements_Bilan",
    },
  },

  attributes: [
    { label: "id", value: "id", type: "int", is_default:"true" },
    { label: "element_name", value: "element_name", type: "str", is_default:"true" },
    { label: "wbs_name", value: "wbs_name", type: "str" },
    { label: "element_type", value: "element_type", type: "str" },
    { label: "level", "value": "level", type: "str" },
    { label: "description", value: "description", type: "str", is_default:"true" },
    { label: "system_subsystem_element_description", value: "system_subsystem_element_description", type: "str"},
    { label: "pbscode", value: "pbscode", type: "str", is_default:"true" },
    { label: "parent_id", value: "parent_id", type: "int", is_default:"true" },
    { label: "pbs_element_manager", value: "pbs_element_manager", type: "str", is_default:"true" },
    { label: "manager_email", value: "manager_email", type: "str", is_default:"true"},
    { label: "review", value: "review", type: "str", is_default:"true"},
    { label: "created_at", value: "created_at", type: "date" },
    { label: "updated_at", value: "updated_at", type: "date" }, 
    
    { label: "Having_no_params_yet", value: "Having_no_params_yet", type: "proposition", "select":[
      "true",
      "false"
      ],
      is_default:"hidden"
    },
    { label: "Atomic", value: "Atomic",
      type: "proposition",
      "select":[
        "true",
        "false"
      ],
      is_default:"hidden"
    }
  ],
  conditions: Conditions,

  formFields: [
    { key: "element_name", label: "element_name",type: 'input' },
    { key: "wbs_name", label: "wbs_name",type: 'input' },
    { key: "element_type", label: "element_type",type: 'input' },
    { key: "parent_id", label: "parent_id", type: 'Autocomplete' , Autocomplete:combboxElements},
    { key: "level", label: "level",type: 'input' },
    { key: "description", label: "description",type: 'input' },
    { key: "system_subsystem_element_description", label: "system_subsystem_element_description",type: 'input' },
    { key: "pbscode", label: "pbscode",type: 'input' },
    { key: "pbs_element_manager", label: "pbs_element_manager", type: 'input' },
    { key: "manager_email", label: "manager_email", type: 'input' },
    { key: "review", label: "review",type: 'input' },
  ],

  defaultFilters : [],


  // =========================
  // TABS CONFIG (CUSTOM PER ENTITY)
  // =========================
  tabs: [
    {
      label: "All",
      filters: [],   // tabIndex 0
    },
    {
      label: "HFI",
      filters: [{attribute:'pbscode',condition:'start',value:'1.1',type:'str'}],   // tabIndex 1
     
    },
    {
      label: "LFI",
      filters: [{attribute:'pbscode',condition:'start',value:'1.2',type:'str'}],   // tabIndex 2
       
    },
  ],
};
